import { render, staticRenderFns } from "./NavBarZone.vue?vue&type=template&id=28589bc8&"
import script from "./NavBarZone.vue?vue&type=script&lang=js&"
export * from "./NavBarZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports